var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5453AE3E-AF19-48EB-99D9-B41887AC8A06@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1227.000000, -776.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    id: "icon/social/twitter"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227.204572, 776.023024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5478204,19.5049949 C16.6050322,19.5049949 21.5577213,12.00156 21.5577213,5.49509557 C21.5577213,5.28197235 21.5533804,5.06981074 21.5438207,4.85860832 C22.5052695,4.16356188 23.3409584,3.29619302 24,2.30882255 C23.117756,2.70098658 22.1683071,2.9649898 21.1722966,3.08403141 C22.1889471,2.47442416 22.9694344,1.5100953 23.3375984,0.360483221 C22.3862287,0.924488859 21.3326183,1.33441369 20.210847,1.5556953 C19.3122781,0.598565638 18.0330652,-7.10542736e-15 16.6165715,-7.10542736e-15 C13.8973442,-7.10542736e-15 11.6922016,2.20514255 11.6922016,4.92340913 C11.6922016,5.30981235 11.7354016,5.68565718 11.8198832,6.0461396 C7.72736295,5.84021799 4.0985251,3.88083866 1.67018174,0.901448859 C1.24729691,1.62913611 1.0034553,2.47442416 1.0034553,3.37635302 C1.0034553,5.08469074 1.87274336,6.59286604 3.19467624,7.4751149 C2.38682899,7.4501549 1.62794094,7.22839168 0.964573691,6.85926846 C0.963848859,6.87992779 0.963848859,6.90006926 0.963848859,6.92214926 C0.963848859,9.30681262 2.66114658,11.2978728 4.91428913,11.7490768 C4.5005251,11.8618784 4.06516027,11.9223584 3.61587624,11.9223584 C3.29907302,11.9223584 2.9904298,11.8911777 2.69042738,11.8335584 C3.31731302,13.7900577 5.13509074,15.2137514 7.29031329,15.253593 C5.60501557,16.5745651 3.48195463,17.361294 1.17457208,17.361294 C0.777607248,17.361294 0.385444027,17.3387146 0,17.2931323 C2.17922255,18.6899477 4.76692832,19.5049949 7.5480749,19.5049949",
    id: "path3611"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooterTwitter);
export default __webpack_public_path__ + "static/media/icon-footer-twitter.5da2e0619a94105e412269becd95a42a.svg";
export { ForwardRef as ReactComponent };